import { CheckCircleIcon, HStack, Text, useToken } from 'native-base';
import React from 'react';

import { Reservation2 } from 'app/components/icons';
import { EntitlementReservation } from 'app/services/GuestCenterService.types';
import { hasUsage, reservationLabel } from 'app/services/ReservationHelper';

export type ReservationTimeLabelProps = {
  reservation: EntitlementReservation;
};

export default function ReservationTimeLabel({ reservation }: ReservationTimeLabelProps) {
  const brandSecondary = useToken('colors', 'brand.secondary');
  const usage = hasUsage(reservation);
  const color = usage ? brandSecondary : '#0284C7';

  return (
    <HStack alignItems="center" space="1" testID="ReservationLabel">
      {usage ? (
        <CheckCircleIcon color={color} size="14px" />
      ) : (
        <Reservation2 color={color} size={14} />
      )}
      <Text bold={!usage} color={color} fontSize="sm">
        {reservationLabel(reservation)}
      </Text>
    </HStack>
  );
}
